// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","footer-small-text":"Footer_footer-small-text__QNEHP"};